module.exports = __webpack_public_path__ + "img/financing.dfd73e2b.svg";